var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 51,
    rx: 2.52385,
    fill: "#E6F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3387 26.3554L34.3337 26.3344L31.5253 18.8614C31.4002 18.4394 31.0272 18.1484 30.6042 18.1484H19.2204C18.7949 18.1484 18.4169 18.4446 18.2968 18.8719L15.6711 26.2689L15.6636 26.2872L15.6586 26.3082C15.626 26.4367 15.616 26.5677 15.6335 26.6962C15.631 26.7381 15.6285 26.78 15.6285 26.822V36.4129C15.6292 36.8354 15.7897 37.2403 16.075 37.5391C16.3603 37.8378 16.747 38.0059 17.1504 38.0066H32.8494C33.688 38.0066 34.3713 37.291 34.3738 36.4129V26.822C34.3738 26.7879 34.3738 26.7538 34.3713 26.725C34.3813 26.5965 34.3713 26.4734 34.3387 26.3554ZM26.9348 25.2283L26.9272 25.6398C26.9072 26.8167 26.1313 27.6083 24.9974 27.6083C24.4442 27.6083 23.9687 27.4222 23.6257 27.0684C23.2828 26.7145 23.0951 26.2217 23.0851 25.6398L23.0776 25.2283H17.9263L19.9162 20.1615H29.9084L31.9534 25.2283H26.9348ZM17.5484 27.2414H21.4856C22.0939 28.7381 23.3879 29.6214 24.9999 29.6214C25.8434 29.6214 26.6269 29.375 27.2602 28.9084C27.8158 28.4995 28.2489 27.9281 28.5292 27.2414H32.4464V35.9935H17.5484V27.2414Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag_icon.564a714229c73627c85988161e1b9948.svg";
export { ForwardRef as ReactComponent };